export const INBOX_LAYOUT_NAV_HEIGHT = 60
export const INBOX_CONTEXT_PANEL_MIN_WIDTH = 360
export const INBOX_CONTEXT_PANEL_WIDTH = 420
export const INBOX_CONTEXT_PANEL_THRESHOLD = 830
